import { render, staticRenderFns } from "./PositionsAndOffset.vue?vue&type=template&id=dcbc5fe8"
import script from "./PositionsAndOffset.vue?vue&type=script&lang=js"
export * from "./PositionsAndOffset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports